import { Component, TemplateFunction } from '@ribajs/core'

import type { SbProductVariantImageDetails } from '../types/index.js'

/**
 * The types for the scope
 */
interface Scope {
  // OPTIONS / DATA

  /** Extracted images by variant */
  images: SbProductVariantImageDetails[]

  // METHODS
  onImageLoaded: SbPopupProductVariantsGalleryBodyComponent['onImageLoaded']

  // TEMPLATES
}

/**
 * A component to show the product (variant) images in fullscreen in a popup
 */
export class SbPopupProductVariantsGalleryBodyComponent extends Component {
  public static tagName = 'sb-popup-product-variants-gallery-body'

  public scope: Scope = {
    // OPTIONS / DATA
    images: [],

    // METHODS
    onImageLoaded: this.onImageLoaded,

    // TEMPLATES
  }

  static get observedAttributes(): string[] {
    return ['images']
  }

  protected async onImageLoaded(
    image: SbProductVariantImageDetails | undefined,
    eventName: 'changed' | 'loaded',
  ) {
    if (typeof image === 'object') {
      image.loadedFull = eventName === 'loaded'
    } else {
      this.debug(
        'onImageLoaded: image is not defined, is the popup destroyed?',
        image,
      )
    }
  }

  protected requiredAttributes(): string[] {
    return []
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbPopupProductVariantsGalleryBodyComponent.observedAttributes)
  }

  protected async afterBind() {
    await super.afterBind()
    this.classList.add(
      `${SbPopupProductVariantsGalleryBodyComponent.tagName}-ready`,
    )
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
